import type { AuthUser } from "@edlab-fms/shared";
import { formatRoleLabel } from "../../lib/format/role";

interface ScopeCardProps {
  user: AuthUser;
}

export function ScopeCard({ user }: ScopeCardProps) {
  const scopeLabel =
    user.permissions.unitScope === "all"
      ? "All programmes"
      : `${user.permissions.unitScope.length} assigned programmes`;

  const roleHint =
    user.role === "accounts" && user.permissions.unitScope !== "all"
      ? "CARE is excluded from this account."
      : user.role === "project_lead"
        ? "Hasan Academy only."
        : user.role === "donor"
          ? "Only the selected donor's funding is displayed."
          : user.role === "board_member"
            ? "Read-only access for board oversight."
            : user.role === "auditor"
              ? "Audit and bank visibility only."
              : null;

  return (
    <div className="rounded-xl border border-[#e0e5e9] bg-white/55 p-[13px] text-xs leading-normal text-[#6c7681]">
      <b className="mb-1 block text-[13px] text-[#394a50]">
        <span aria-hidden className="mr-1">
          ◆
        </span>
        {user.role === "donor" ? "Your funding only" : scopeLabel}
      </b>
      <p className="mt-1">{formatRoleLabel(user.role)}</p>
      {roleHint ? <p className="mt-2">{roleHint}</p> : null}
    </div>
  );
}
